import React from 'react';
import { X, Sparkles } from 'lucide-react';
import type { VideoBackgroundEffect } from '../types/meeting.types.ts';

const EFFECTS: Array<{ id: VideoBackgroundEffect; label: string; preview: string }> = [
  { id: 'none', label: 'Yok', preview: 'bg-slate-700' },
  { id: 'blur', label: 'Bulanık', preview: 'bg-slate-500 blur-sm' },
  { id: 'purple', label: 'Mor gradyan', preview: 'bg-gradient-to-br from-purple-700 to-slate-900' },
  { id: 'blue', label: 'Mavi gradyan', preview: 'bg-gradient-to-br from-blue-700 to-slate-900' },
  { id: 'transparent', label: 'Şeffaf', preview: 'bg-slate-800/30 border border-dashed border-white/30' },
];

interface BackgroundEffectsModalProps {
  isOpen: boolean;
  effect: VideoBackgroundEffect;
  onClose: () => void;
  onChange: (effect: VideoBackgroundEffect) => void;
}

const BackgroundEffectsModal: React.FC<BackgroundEffectsModalProps> = ({
  isOpen,
  effect,
  onClose,
  onChange,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[65] p-4">
      <div className="bg-slate-800 rounded-2xl border border-white/10 w-full max-w-md p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-purple-400" />
            <h2 className="text-lg font-bold text-white">Arka planlar ve efektler</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white/10 text-gray-400 hover:text-white transition"
            aria-label="Kapat"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-gray-400 text-sm mb-4">
          Kamera görüntünüzdeki kişi otomatik tanınır; efektler yalnızca arka plana uygulanır (Zoom benzeri).
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {EFFECTS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange(item.id)}
              className={`rounded-xl overflow-hidden border-2 transition ${
                effect === item.id ? 'border-purple-500 ring-2 ring-purple-500/40' : 'border-white/10 hover:border-white/30'
              }`}
            >
              <div className={`h-16 ${item.preview}`} />
              <p className="text-white text-xs py-2 bg-white/5">{item.label}</p>
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-medium transition"
        >
          Tamam
        </button>
      </div>
    </div>
  );
};

export default BackgroundEffectsModal;
